<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />

        <div class="row">
          <div class="col-xl-3 col-md-4">
            <settingsidebar />
          </div>

          <div class="col-xl-9 col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Payment</h5>
              </div>
              <div class="card-body">
                <div class="card w-100 mb-3">
                  <div
                    class="card-body d-flex align-items-center justify-content-between p-0"
                  >
                    <div class="d-flex align-items-center">
                      <div class="img_wrapper">
                        <img src="@/assets/img/paystack.png" alt="" />
                      </div>
                      <div>
                        <h5 class="card-title">Paystack</h5>
                        <p class="card-text">
                          <span class="text-black">Status: </span>
                          <span
                            class="text-success"
                            v-if="
                              keys?.paystack && keys?.paystack?.active === 1
                            "
                            >Active</span
                          >
                          <span
                            class="text-danger"
                            v-else-if="
                              keys?.paystack && keys?.paystack?.active === 0
                            "
                            >Inactive</span
                          >
                          <span class="text-danger" v-else>Inactive</span>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="form-group" v-if="keys?.paystack?.public_key">
                        <div class="check-mark-status">
                          <div class="status-toggle mt-2">
                            <input
                              id="paystack"
                              class="check"
                              @change="toggleKeys('paystack')"
                              :checked="keys?.paystack?.active"
                              type="checkbox"
                            />
                            <label
                              for="paystack"
                              class="checktoggle checkbox-bg"
                              >checkbox</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="text-end">
                        <b-button
                          @click="openPaystackModal('paystack')"
                          variant="primary"
                          >Configure</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card w-100 mb-3">
                  <div
                    class="card-body d-flex align-items-center justify-content-between p-0"
                  >
                    <div class="d-flex align-items-center">
                      <div class="stripe_wrapper">
                        <img
                          class="stripe"
                          src="@/assets/img/stripe.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <h5 class="card-title">Stripe</h5>
                        <p class="card-text">
                          <span class="text-black">Status: </span>
                          <span
                            class="text-success"
                            v-if="keys?.stripe && keys?.stripe?.active === 1"
                            >Active</span
                          >
                          <span
                            class="text-danger"
                            v-else-if="
                              keys?.stripe && keys?.stripe?.active === 0
                            "
                            >Inactive</span
                          >
                          <span class="text-danger" v-else>Inactive</span>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="form-group" v-if="keys?.stripe?.public_key">
                        <div class="check-mark-status">
                          <div class="status-toggle mt-2">
                            <input
                              id="stripe"
                              class="check"
                              :checked="keys?.stripe?.active"
                              @change="toggleKeys('stripe')"
                              type="checkbox"
                            />
                            <label for="stripe" class="checktoggle checkbox-bg"
                              >checkbox</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="text-end">
                        <b-button
                          @click="openPaystackModal('stripe')"
                          variant="primary"
                          >Configure</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card w-100 mb-3">
                  <div
                    class="card-body d-flex align-items-center justify-content-between p-0"
                  >
                    <div class="d-flex align-items-center">
                      <div class="img_wrapper">
                        <img src="@/assets/img/paypal.webp" alt="" />
                      </div>
                      <div>
                        <h5 class="card-title">Paypal</h5>
                        <p class="card-text">
                          <span class="text-black">Status: </span>
                          <span
                            class="text-success"
                            v-if="keys?.paypal && keys?.paypal?.active === 1"
                            >Active</span
                          >
                          <span
                            class="text-danger"
                            v-else-if="
                              keys?.paypal && keys?.paypal?.active === 0
                            "
                            >Inactive</span
                          >
                          <span class="text-danger" v-else>Inactive</span>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="form-group" v-if="keys?.paypal?.client_id">
                        <div class="check-mark-status">
                          <div class="status-toggle mt-2">
                            <input
                              id="paypal"
                              class="check"
                              @change="toggleKeys('paypal')"
                              :checked="keys?.paypal?.active"
                              type="checkbox"
                            />
                            <label for="paypal" class="checktoggle checkbox-bg"
                              >checkbox</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="text-end">
                        <b-button
                          @click="openPaypalModal('paypal')"
                          variant="primary"
                          >Configure</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
  <!-- Paystack modal -->
  <div class="modal custom-fade fade" id="paystack_modal" role="dialog">
    <div class="modal-dialog modal-top modal-md">
      <form @submit.prevent="updatePaystackPayment" class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 v-if="payment === 'paystack'" class="mb-0">
              Configure Paystack
            </h4>
            <h4 v-else-if="payment === 'stripe'" class="mb-0">
              Configure Stripe
            </h4>
          </div>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group set_input">
                <label>Secret key </label>
                <input
                  v-model="paystack_form.secret_key"
                  :type="showSecretkey ? 'password' : 'text'"
                  class="form-control"
                  placeholder="Enter Secret key"
                  required
                />
                <span
                  @click="showSecretkey = !showSecretkey"
                  class="fas toggle-password2 set_eye"
                  :class="{
                    'fa-eye': showSecretkey,
                    'fa-eye-slash': !showSecretkey,
                  }"
                ></span>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Public key </label>
                <input
                  type="text"
                  v-model="paystack_form.public_key"
                  class="form-control"
                  placeholder="Enter Public key"
                  required
                />
              </div>
            </div>

            <div class="col-12" v-if="payment === 'stripe'">
              <div class="form-group">
                <label>Webhook ID </label>
                <input
                  type="text"
                  v-model="paystack_form.webhook_id"
                  class="form-control"
                  placeholder="Enter Webhook ID"
                  required
                />
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label class="custom_check me-3">
                  <input
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    v-model="paystack_form.active"
                    name="active"
                  />
                  <span class="checkmark"></span> Activate
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a data-bs-dismiss="modal" class="btn btn-primary cancel me-2">
            Cancel
          </a>
          <button
            v-if="payment === 'paystack'"
            type="submit"
            :disabled="isLoading"
            class="btn btn-primary"
          >
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="!isLoading">Save</span>
            <span v-if="isLoading">Saving...</span>
          </button>
          <button
            v-if="payment === 'stripe'"
            type="submit"
            :disabled="isLoading"
            class="btn btn-primary"
          >
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="!isLoading">Save</span>
            <span v-if="isLoading">Saving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
  <!-- Paypal modal -->
  <div class="modal custom-fade fade" id="paypal_modal" role="dialog">
    <div class="modal-dialog modal-top modal-md">
      <form @submit.prevent="updatePaypalPayment" class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Configure Paypal</h4>
          </div>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Username </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="paypal_form.client_id"
                  placeholder="Enter Username"
                  required
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group set_input">
                <label>Password </label>
                <input
                  :type="showSecretkey ? 'password' : 'text'"
                  class="form-control"
                  v-model="paypal_form.client_secret"
                  placeholder="Enter Password"
                  required
                />
                <span
                  @click="showSecretkey = !showSecretkey"
                  class="fas toggle-password2 set_eye"
                  :class="{
                    'fa-eye': showSecretkey,
                    'fa-eye-slash': !showSecretkey,
                  }"
                ></span>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group set_input">
                <label>Signature </label>
                <input
                  :type="showEncryptionkey ? 'password' : 'text'"
                  class="form-control"
                  v-model="paypal_form.webhook_id"
                  placeholder="Enter Encryption key"
                  required
                />
                <span
                  @click="showEncryptionkey = !showEncryptionkey"
                  class="fas toggle-password2 set_eye"
                  :class="{
                    'fa-eye': showEncryptionkey,
                    'fa-eye-slash': !showEncryptionkey,
                  }"
                ></span>
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label class="custom_check me-3">
                  <input
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    v-model="paypal_form.active"
                    name="active"
                  />
                  <span class="checkmark"></span> Activate
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a data-bs-dismiss="modal" class="btn btn-primary cancel me-2">
            Cancel
          </a>
          <button type="submit" :disabled="isLoading" class="btn btn-primary">
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="!isLoading">Save</span>
            <span v-if="isLoading">Saving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { Modal } from "bootstrap";
import { useStore } from "vuex";

const store = useStore();
const isLoading = ref(false);
const paystackModal = ref(null);
const paypalModal = ref(null);
const payment = ref("");
const title = "Settings";
const showSecretkey = ref(true);
const showEncryptionkey = ref(true);

const paystack_form = ref({
  type: "",
  public_key: "",
  secret_key: "",
  webhook_id:'',
  active: "",
});
const paypal_form = ref({
  type: "",
  client_id: "",
  client_secret: "",
  webhook_id: "",
  active: "",
});

const keys = computed(() => {
  return store.getters["settings/paymentkeys"];
});

const user = computed(() => {
  return store.getters["auth/user"];
});

// This will work for paystack and stripe
const openPaystackModal = (name) => {
  showSecretkey.value = true;
  payment.value = name;
  if (name === "paystack") {
    paystack_form.value = {
      type: name,
      public_key: keys.value.paystack.public_key,
      secret_key: keys.value.paystack.secret_key,
      active: keys.value.paystack.active ? keys.value.paystack.active : 0,
    };
  } else {
    paystack_form.value = {
      type: name,
      public_key: keys.value.stripe.public_key,
      webhook_id:keys.value.stripe.webhook_id,
      secret_key: keys.value.stripe.secret_key,
      active: keys.value.stripe.active ? keys.value.stripe.active : 0,
    };
  }
  paystackModal.value.show();
};

const openPaypalModal = (name) => {
  showSecretkey.value = true;
  showEncryptionkey.value = true;
  payment.value = name;
  paypal_form.value = {
    type: name,
    client_id: keys.value.paypal.client_id,
    client_secret: keys.value.paypal.client_secret,
    webhook_id: keys.value.paypal.webhook_id,
    active: keys.value.paypal.active ? keys.value.paypal.active : 0,
  };
  paypalModal.value.show();
};

const updatePaystackPayment = () => {
  isLoading.value = true;
  store
    .dispatch("settings/updatePayment", paystack_form.value)
    .then(() => {
      isLoading.value = false;
      paystackModal.value.hide();
      getPaymentkeys();
    })
    .catch(() => {
      isLoading.value = false;
    });
};

const updatePaypalPayment = () => {
  isLoading.value = true;
  store
    .dispatch("settings/updatePayment", paypal_form.value)
    .then(() => {
      isLoading.value = false;
      paypalModal.value.hide();
      getPaymentkeys();
    })
    .catch(() => {
      isLoading.value = false;
    });
};

const getPaymentkeys = () => {
  store.dispatch("settings/getPaymentkeys");
};

const toggleKeys = (name) => {
  if (name === "paystack") {
    paystack_form.value = {
      type: name,
      public_key: keys.value.paystack.public_key,
      secret_key: keys.value.paystack.secret_key,
      active: keys.value.paystack.active === 1 ? 0 : 1,
    };
    updatePaystackPayment();
  } else if (name === "stripe") {
    paystack_form.value = {
      type: name,
      public_key: keys.value.stripe.public_key,
      secret_key: keys.value.stripe.secret_key,
      active: keys.value.stripe.active === 1 ? 0 : 1,
    };
    updatePaystackPayment();
  } else {
    paypal_form.value = {
      type: name,
      client_id: keys.value.paypal.client_id,
      client_secret: keys.value.paypal.client_secret,
      webhook_id: keys.value.paypal.webhook_id,
      active: keys.value.paypal.active === 1 ? 0 : 1,
    };
    updatePaypalPayment();
  }
};

onMounted(() => {
  getPaymentkeys();
  // Initiate modal
  paystackModal.value = new Modal(document.getElementById("paystack_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  paypalModal.value = new Modal(document.getElementById("paypal_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>

<style scoped>
.img_wrapper {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.img_wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.stripe_wrapper {
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border-radius: 50%;
}
.stripe_wrapper .stripe {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
}

.set_input {
  position: relative;
}
.set_eye {
  margin-top: 22px;
  margin-right: -10px;
}
</style>
